import { memo } from 'react';

import { DRGPNT_POSITION_Y_DEFAULT } from '@/apps/mwd-v2/utils/deeltraject';
import { Group } from '@visx/group';
import { Text } from '@visx/text';

import styles from '@/apps/mwd-v2/components/Domain/MwdChart.module.css';

type LocatieLabelProps = {
  positionLeft: number;
  dienstregelpunt: string;
};

const LocatieLabel = ({ positionLeft, dienstregelpunt }: LocatieLabelProps) => {
  return (
    <Group left={positionLeft}>
      <rect y={DRGPNT_POSITION_Y_DEFAULT - 11} width={35} height={13} fill='transparent' />
      <Text className={styles.werklijnLabelStyleV2} y={DRGPNT_POSITION_Y_DEFAULT} pointerEvents='none'>
        {dienstregelpunt}
      </Text>
    </Group>
  );
};

export default memo(LocatieLabel);
